import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container
      header={
        <Header variant="h1">
          Access Denied
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <Box>
          You don't have permission to access this page. Analytics dashboard access is restricted to authorized administrators only.
        </Box>
        
        <Box>
          <Button variant="primary" onClick={() => navigate('/')}>
            Return to Homepage
          </Button>
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default Unauthorized;
